import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import walls0 from "./components/walls-0";
import walls1 from "./components/walls-1";
import walls2 from "./components/walls-2";
import walls3 from "./components/walls-3";
import walls4 from "./components/walls-4";
import walls5 from "./components/walls-5";
import walls6 from "./components/walls-6";

const principle: Slide = {
  description:
    "Boundary conditions decreases the degree of freedom and hence reduces the solution space of the wave equation. Select the reflecting planes you want to add and look how the basis of plane wave solutions changes when perfectly reflecting planes are added.",
  theory: theory,
  layout: {
    type: "custom011800",
    options: {
      data: {
        ...walls0,
        ...walls1,
        ...walls2,
        ...walls3,
        ...walls4,
        ...walls5,
        ...walls6,
      },
    },
  },
};

export default principle;
